<div class="print-header mb-4 mt-2">
  <header>
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column align-items-start gap-1">
        <p class="fw-bold font-18">{{ "REPORTS.OMAN" | translate }}</p>
        <p class="fw-bold font-18">{{ "REPORTS.NATIONAL_MUSEUM" | translate }}</p>
        <p>{{ title() || "" | translate }}</p>
      </div>

      <div class="d-flex logo align-items-center">
        <img class="mx-3 cursor-pointer" src="assets/images/logo-with-text.png" alt="Logo Photo" [width]="120" />
      </div>
    </div>
  </header>
  <hr class="w-100 mt-1 mb-3" />
  <div class="row">
    <div class="col-6">
      @if (dateFrom()!) {
        <p class="fw-bold font-18">{{ "REPORTS.DATE_FROM" | translate }}: {{ dateFrom() | date: "dd/MM/yyyy" }}</p>
      }
      <p class="fw-bold font-18">{{ "REPORTS.DATE_TO" | translate }}: {{ dateTo() || today | date: "dd/MM/yyyy" }}</p>
    </div>
  </div>
</div>
